var _rect, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddAvatarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#388AF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 15.25V10.25C18.5 9.14543 17.6046 8.25 16.5 8.25H16.3284C15.798 8.25 15.2893 8.03929 14.9142 7.66421L14.5858 7.33579C14.2107 6.96071 13.702 6.75 13.1716 6.75H11.8284C11.298 6.75 10.7893 6.96071 10.4142 7.33579L10.0858 7.66421C9.71071 8.03929 9.20201 8.25 8.67157 8.25H8.5C7.39543 8.25 6.5 9.14543 6.5 10.25V15.25C6.5 16.3546 7.39543 17.25 8.5 17.25H16.5C17.6046 17.25 18.5 16.3546 18.5 15.25Z",
    stroke: "#FDFDFE",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 2.25,
    stroke: "#FDFDFE",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAvatarIcon);
export default __webpack_public_path__ + "static/media/add_avatar_icon.aa62e66691f5a453e7dffa310babc727.svg";
export { ForwardRef as ReactComponent };